import { onboardingType } from '@config/types'

const ONBOARDING_CONFIG: onboardingType = {
  avatar: {
    title: 'Select Skin and Mint',
    subtitle:
      'This is your soulbound NFT and it acts as a digital passport to the Libertas Omnibus Nation. It’s free to mint, can’t be transferred, and can be customized once minted'
  },
  welcome: {
    subtitle: 'You have now minted your NFT and you’re ready to enter the Libertas Omnibus Nation. '
  }
}

export default ONBOARDING_CONFIG
